import {useMutation} from "@tanstack/react-query";
import {ExchangeSearchParamType} from "../interface";
import {readExchangeRate} from "../../../../../api/main/ExchangeApi";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";

type Props = {
    param: ExchangeSearchParamType;
};

export const useReadExchangeRate = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (param: ExchangeSearchParamType) => readExchangeRate(param),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    })

    return {mutate, mutateAsync}
};
